import NotFound from "modules/not-found"
import Claims from "modules/claims"
import Sandbox from "modules/sandbox"

// STEP-FORM
import Step1 from "modules/claims/components/StepForm/Step1"
import Step2 from "modules/claims/components/StepForm/Step2"
import Step3 from "modules/claims/components/StepForm/Step3"
import Step4 from "modules/claims/components/StepForm/Step4"
import Step5 from "modules/claims/components/StepForm/Step5"
import Step6 from "modules/claims/components/StepForm/Step6"
import ThankYouClaims from "modules/claims/components/StepForm/ThankYou"

export const LANDING_WISHPER_NEO_PLUS = "LANDING_WISHPER_NEO_PLUS"
export const THANK_YOU_WISHPER_NEO_PLUS = "THANK_YOU_WISHPER_NEO_PLUS"
export const LANDING_RIVULET = "LANDING_RIVULET"
export const THANK_YOU_RIVULET = "THANK_YOU_RIVULET"
export const LANDING_PRANNA = "LANDING_PRANNA"
export const THANK_YOU_PRANNA = "THANK_YOU_PRANNA"
export const THANK_YOU_PANDORA = "THANK_YOU_PANDORA"
export const FERIA_TAPICERIA = "FERIA_TAPICERIA"
export const CLAIMS = "CLAIMS"
export const THANK_YOU_CLAIMS = "THANK_YOU_CLAIMS"
export const PETFRIENDLY = "PETFRIENDLY"
export const THANK_YOU_PETFRIENDLY = "THANK_YOU_PETFRIENDLY"
export const PERMACOOL = "PERMACOOL"
export const THANK_YOU_PERMACOOL = "THANK_YOU_PERMACOOL"
export const BREEZE = "BREEZE"
export const THANK_YOU_BREEZE = "THANK_YOU_BREEZE"
export const SUSTAINABILITY_REPORTS_ES = "SUSTAINABILITY_REPORTS_ES"
export const SUSTAINABILITY_REPORTS_EN = "SUSTAINABILITY_REPORTS_EN"
export const FLOORS = "FLOORS"
export const THANK_YOU_FLOORS = "THANK_YOU_FLOORS"
export const FLOORS_EXTERNAL = "FLOORS_EXTERNAL"
export const FLOORS_INSPIRATION_DETAIL = "FLOORS_INSPIRATION_DETAIL"
export const FLOORS_GUIDE = "FLOORS_GUIDE"
export const FLOORS_DELIVERABLES = "FLOORS_DELIVERABLES"
export const DETAIL_FLOOR_INTERN = "DETAIL_FLOOR_INTERN"
export const DETAIL_FLOOR = "DETAIL_FLOOR"
export const LANDING_DALI = "LANDING_DALI"
export const THANK_YOU_DALI = "THANK_YOU_DALI"
export const LANDING_LINETEX = "LANDING_LINETEX"
export const THANK_YOU_LINETEX = "THANK_YOU_LINETEX"
export const LANDING_IBEX = "LANDING_IBEX"
export const LANDING_IMPALA = "LANDING_IMPALA"
export const THANK_YOU_IMPALA = "THANK_YOU_IMPALA"
export const LANDING_VESTUARIO_Y_PROTECCION = "LANDING_VESTUARIO_Y_PROTECCION"
export const DETAIL_REFERENCE_VESTUARIO_Y_PROTECCION = "DETAIL_REFERENCE_VESTUARIO_Y_PROTECCION"
export const THANK_YOU_VESTUARIO_Y_PROTECCION = "THANK_YOU_VESTUARIO_Y_PROTECCION"
export const LANDING_PANDORA = "LANDING_PANDORA"
export const LANDING_PRANNATEX = "LANDING_PRANNATEX"
export const LANDING_CLEANING_GUIDE_MARINE = "LANDING_CLEANING_GUIDE_MARINE"
export const LANDING_CLEANING_GUIDE_MARINE_GENERAL = "LANDING_CLEANING_GUIDE_MARINE_GENERAL"
export const LANDING_CLEANING_GUIDE_MARINE_CHIL = "LANDING_CLEANING_GUIDE_MARINE_CHIL"
export const THANK_YOU_PRANNATEX = "THANK_YOU_PRANNATEX"
export const LANDING_SEGMENTS_HOTEL = "LANDING_SEGMENTS_HOTEL"
export const THANK_YOU_SEGMENTS_HOTEL = "THANK_YOU_SEGMENTS_HOTEL"
export const LANDING_MASIALA = "LANDING_MASIALA"
export const LANDING_QUICKSHIP = "LANDING_QUICKSHIP"
export const LANDING_QUICKSHIP_SLUG = "LANDING_QUICKSHIP_SLUG"
export const THANK_YOU_LANDING_MASIALA = "THANK_YOU_LANDING_MASIALA"
export const LANDING_SAXONY = "LANDING_SAXONY"
export const THANK_YOU_SAXONY = "THANK_YOU_SAXONY"
export const LANDING_KIZUNA_HOME = "LANDING_KIZUNA_HOME"
export const LANDING_KIZUNA_DETAIL = "LANDING_KIZUNA_DETAIL"
export const NOT_FOUND = "NOT_FOUND"
export const SANDBOX = "SANDBOX"
// START -> STEP-FORM
export const STEP_1 = "STEP_1"
export const STEP_2 = "STEP_2"
export const STEP_3 = "STEP_3"
export const STEP_4 = "STEP_4"
export const STEP_5 = "STEP_5"
export const STEP_6 = "STEP_6"
export const STEP_RESULT = "STEP_RESULT"
// END -> STEP-FORM

// const locationPath = "/:language-:instance"
const locationPath = "/en-eu"

export const ROUTES = {
  [CLAIMS]: {
    path: `${locationPath}`,
    exact: true,
    element: <Claims />
  },
  [STEP_1]: {
    path: `${locationPath}/claims/step-1`,
    exact: true,
    element: <Step1 />
  },
  [STEP_2]: {
    path: `${locationPath}/claims/step-2`,
    exact: true,
    element: <Step2 />
  },
  [STEP_3]: {
    path: `${locationPath}/claims/step-3`,
    exact: true,
    element: <Step3 />
  },
  [STEP_4]: {
    path: `${locationPath}/claims/step-4`,
    exact: true,
    element: <Step4 />
  },
  [STEP_5]: {
    path: `${locationPath}/claims/step-5`,
    exact: true,
    element: <Step5 />
  },
  [STEP_6]: {
    path: `${locationPath}/claims/step-6`,
    exact: true,
    element: <Step6 />
  },
  [THANK_YOU_CLAIMS]: {
    path: `${locationPath}/claims/thank-you`,
    exact: true,
    element: <ThankYouClaims />
  },
  [SANDBOX]: {
    path: "sandbox",
    element: <Sandbox />
  },
  [NOT_FOUND]: {
    path: "*",
    element: <NotFound />
  }
}
